'use strict'

define ['./login.css'], () ->
  ($scope, $rootScope, $state, RentappService, $stateParams, $cookies) ->
    LogRocket = require('logrocket')

    if $rootScope.WHITE_LABEL
      require('./../../bare_home/landing.scss')
      $scope.company_logo_large_url = $rootScope.COMPANY_LOGO_LARGE_URL
    
    if $stateParams.view_app
      $scope.view_app = $stateParams.view_app
    
    $scope.getPath = (user) ->
      path = ""
      if user.landlord
        if user.active_app_count > 0
          path = "root.dashboard.applications"
        else
          path = "root.dashboard.forms"

        $cookies.put("just_logged_in", true)
      else
        path = "root.dashboard.applicant_applications"
      path
    
    # If user is already logged in
    # redirect to appropriate path
    RentappService.getMe()
    .then (user) ->
      path = $scope.getPath(user)
      $state.go path
        
    $scope.close_error = () ->
       $scope.wrong_login = null

    $scope.login = (username, password) ->
      $scope.logging_in = true
      $scope.is_locked = false
      $scope.wrong_login = false
      RentappService.login(username, password)
      .then (user) ->
        if $rootScope.LOGROCKET_ID
          LogRocket.identify(user.username, user)

        if $scope.view_app
          $state.go "root.dashboard.view_application", { application_id: $scope.view_app }
          return 
          
        path = $scope.getPath(user)
        return $state.go path
      .catch (resp) ->
        $scope.attempts_max = resp.data.attempts_max
        if resp.data.locked
          $scope.is_locked = true
        else
          $scope.wrong_login = true
          $scope.attempts_left = resp.data.attempts_max - resp.data.attempts_used

      .finally ->
        $scope.logging_in = false



// WEBPACK FOOTER //
// ./components/home/login/login.coffee